"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstrumentRepository = void 0;
const instruments_json_1 = __importDefault(require("./instruments.json"));
class InstrumentRepository {
    constructor() {
        this._lookup = new Map();
        for (const exchange of Object.keys(instruments_json_1.default)) {
            const instrumentList = instruments_json_1.default[exchange];
            this._lookup.set(exchange, instrumentList);
        }
    }
    getExchanges() {
        return [...this._lookup.keys()];
    }
    getExchangeInstruments(exchange) {
        return this._lookup.get(exchange);
    }
    getExchangeInstrument(exchange, symbol) {
        const symbols = this.getExchangeInstruments(exchange);
        return symbols.find((ins) => ins.symbol === symbol);
    }
}
exports.InstrumentRepository = InstrumentRepository;
